import React, { createContext } from "react";



const initialState = {
  serie: null,
  region: null,
  syndicat: null,
  taille: null,
  isInit: false,
  openedFilter: null,
  visibility: true,
};

const filterReducer = (state, action) => {
  state.serie = typeof innovantsFilters != 'undefined' ? innovantsFilters.serie : null;
  switch (action.type) {
    case "SET_REGION_FILTER":
      return {
        ...state,
        region: action.region,
        syndicat: null,
        taille: null,
        isInit: true,
        openedFilter: null,
      };
    case "SET_OPENED_FILTER":
      return {
        ...state,
        openedFilter: action.openedFilter,
      };
    case "SET_SYNDICAT_FILTER": {
      return {
        ...state,
        syndicat: action.syndicat,
        region: null,
        taille: null,
        isInit: true,
        openedFilter: null,
      };
    }
    case "SET_TAILLE_FILTER": {
      return {
        ...state,
        taille: action.taille,
        region: null,
        syndicat: null,
        isInit: true,
        openedFilter: null,
      };
    }
    case "TOGGLE_FILTERS_VISIBILITY": {
      return {
        ...state,
        openedFilter: null,
        visibility: action.visibility,
      };
    }
    case "RESET_FILTERS": {
      return {
        ...initialState,
        isInit: true,
      };
    }
    default:
      return state;
  }
};
export const FilterContext = createContext();

export const FilterContextProvider = ({ children }) => {
  const [state, dispatch] = React.useReducer(filterReducer, initialState);
  const value = {
    filters: state,
    setRegion: (region) => {
      dispatch({ type: "SET_REGION_FILTER", region });
    },
    setSyndicat: (syndicat) => {
      dispatch({ type: "SET_SYNDICAT_FILTER", syndicat });
    },
    setTaille: (taille) => {
      dispatch({ type: "SET_TAILLE_FILTER", taille });
    },
    setOpenedFilter: (openedFilter) => {
      dispatch({ type: "SET_OPENED_FILTER", openedFilter });
    },
    toggleFilters: (visibility) => {
      dispatch({ type: "TOGGLE_FILTERS_VISIBILITY", visibility });
    },
    resetFilters: () => {
      dispatch({ type: "RESET_FILTERS" });
    },
  };

  return (
    <FilterContext.Provider value={value}>{children}</FilterContext.Provider>
  );
};

// export const FilterContextProvider = FilterContext.Provider;
